// extracted by mini-css-extract-plugin
module.exports = {"link":"navitem-module--link--289BF","linkWithIcon":"navitem-module--linkWithIcon--3VBc1"};